/* ==========================================================================
   AGÄI 2091 — Theme JS
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {

  // Mobile navigation toggle
  const mobileToggle = document.querySelector('.site-header__mobile-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileClose = document.querySelector('.mobile-nav__close');

  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function() {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function() {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Product accordion (FAQ-style details)
  const accordionToggles = document.querySelectorAll('.product__details-toggle');
  accordionToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const item = this.closest('.product__details-item');
      item.classList.toggle('is-open');
    });
  });

  // Product quantity selector
  const quantityInputs = document.querySelectorAll('.product__quantity');
  quantityInputs.forEach(wrapper => {
    const input = wrapper.querySelector('input');
    const minus = wrapper.querySelector('[data-action="minus"]');
    const plus = wrapper.querySelector('[data-action="plus"]');

    if (minus) {
      minus.addEventListener('click', () => {
        const val = parseInt(input.value);
        if (val > 1) input.value = val - 1;
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        input.value = parseInt(input.value) + 1;
      });
    }
  });

  // Product gallery (thumbnails)
  const thumbnails = document.querySelectorAll('.product__thumbnail');
  const mainImage = document.querySelector('.product__main-image img');

  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      const newSrc = this.querySelector('img').src;
      if (mainImage) {
        mainImage.src = newSrc.replace('_small', '_large');
      }
      thumbnails.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');
    });
  });

  // Add to cart via AJAX
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const originalText = button.textContent;
      button.textContent = 'Ajout...';
      button.disabled = true;

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          button.textContent = '✓ Ajouté au panier';
          updateCartCount();
          setTimeout(() => {
            button.textContent = originalText;
            button.disabled = false;
          }, 2000);
        } else {
          throw new Error('Erreur lors de l\'ajout');
        }
      } catch (error) {
        button.textContent = 'Erreur';
        setTimeout(() => {
          button.textContent = originalText;
          button.disabled = false;
        }, 2000);
      }
    });
  });

  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCount = document.querySelector('.site-header__cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
        cartCount.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
    } catch (error) {
      console.error('Erreur cart count:', error);
    }
  }

  // Newsletter form
  const newsletterForms = document.querySelectorAll('form[action*="/contact"]');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function() {
      const button = form.querySelector('button[type="submit"]');
      if (button) button.textContent = 'Envoi...';
    });
  });

  // Smooth header on scroll
  const header = document.querySelector('.site-header');
  let lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.style.boxShadow = '0 1px 8px rgba(0,0,0,0.04)';
      } else {
        header.style.boxShadow = 'none';
      }
      lastScroll = currentScroll;
    });
  }

});
